import {
  BeneficiaryFilterBooleanType,
  BeneficiaryFilterDateType,
  BeneficiaryFilterEnumType,
  BeneficiaryFilterMultiselectType,
  BeneficiaryFilterNumberType,
  BeneficiaryFilterStringType,
} from '@repo/shared/dtos/beneficiary'
import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'

export function buildStringFilter(
  schemaItem: StructuredDataSchemaItem,
): BeneficiaryFilterStringType {
  return {
    key: schemaItem.id,
    type: 'string',
    operator: 'contains',
    value: '',
  }
}

export function buildNumberFilter(
  schemaItem: StructuredDataSchemaItem,
): BeneficiaryFilterNumberType {
  return {
    key: schemaItem.id,
    type: 'number',
    operator: 'eq',
    value: 0,
  }
}

export function buildBooleanFilter(
  schemaItem: StructuredDataSchemaItem,
): BeneficiaryFilterBooleanType {
  return {
    key: schemaItem.id,
    type: 'boolean',
    operator: 'eq',
    value: false,
  }
}

export function buildEnumFilter(schemaItem: StructuredDataSchemaItem): BeneficiaryFilterEnumType {
  return {
    key: schemaItem.id,
    type: 'enum',
    operator: 'in',
    value: [],
  }
}

export function buildMultiselectFilter(
  schemaItem: StructuredDataSchemaItem,
): BeneficiaryFilterMultiselectType {
  return {
    key: schemaItem.id,
    type: 'multiselect',
    operator: 'in',
    value: [],
  }
}

export function buildDateFilter(schemaItem: StructuredDataSchemaItem): BeneficiaryFilterDateType {
  return {
    key: schemaItem.id,
    type: 'date',
    operator: 'eq',
    value: new Date().getTime(),
  }
}

export function resetDateToUTCStartOfDayEpoch(date: Date): number {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)
}
